import React from 'react';
import PropTypes from 'prop-types';
import RadioField from './RadioField';

const RadioFieldAdapter = ({ input, meta, onChange, ...rest }) => {
  const errorMessage = meta && meta.touched && meta.error ? meta.error : '';
  return (
    <RadioField
      {...input}
      {...rest}
      errorMessage={errorMessage}
      onChange={(e) => {
        input.onChange(e.target.value);
        if (onChange) {
          onChange(e);
        }
      }}
    />
  );
};

RadioFieldAdapter.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  onChange: PropTypes.func,
};

export default RadioFieldAdapter;
